module.exports = __webpack_public_path__ + "media/images/talent/case4-img01-8ebc93612be5e672a3ed91d0defef446.png";